import { render, staticRenderFns } from "./ConsultaTerapeuta.vue?vue&type=template&id=267e57d1&scoped=true&"
import script from "./ConsultaTerapeuta.vue?vue&type=script&lang=js&"
export * from "./ConsultaTerapeuta.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaTerapeuta.vue?vue&type=style&index=0&id=267e57d1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e57d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VCol,VContainer,VIcon,VProgressCircular,VRow,VSnackbar})
